module.exports = __webpack_public_path__ + "img/sensor-64.e5295438.png";